export default "__VITE_ASSET__4zcskskf__"